import { isEditing } from '../../../../../Clientside/utils/islands';
import cloudSdkInit from './cloud-sdk';
import initConsents from './consents';
import initGoogleTagManager from './googletagmanager';
export * from './tracking';

export default function () {
    if (!isEditing()) {
        cloudSdkInit();
        initConsents();
        initGoogleTagManager();
    }
}
